import * as React from 'react';

export const CheckmarkSVG = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 214.155 214.155"
            {...props}
        >
            <path d="M74.551 193.448L0 118.896l33.136-33.135 41.415 41.415L181.02 20.707l33.135 33.136L74.551 193.448z" />
        </svg>
    );
};
